// helpers/CouponManager.js

class CouponManager {

    // Constructor
    constructor(vm) {
        this.vm = vm;
    }

    // The call for the actions.js method
    async checkEligibilityAndGetPriceAfterCouponPromo(userId, csMatNo, promoCode, couponID, basePrice, totalPrice, merchantPrice, freeMonth) {
        return this.vm.checkEligibilityAndGetPriceAfterCouponPromo({
            userId: userId,
            csMatNo: csMatNo,
            promoCode: promoCode,
            couponId: couponID,
            basePrice: basePrice,
            totalPrice: totalPrice,
            merchantPrice: merchantPrice,
            freeMonth: freeMonth,
        });
    }

    // The call for the actions.js method
    async checkEligibility(userId, csMatNo, promoID, couponID, freeMonth, merchantPrice) {
        return this.vm.checkEligibility({
            userId: userId,
            csMatNo: csMatNo,
            promoId: promoID,
            couponId: couponID,
            freeMonth: freeMonth,
            merchantPrice: merchantPrice,
        });
    }

    // The call for the actions.js method
    async checkValidity(promoCode, couponID) {
        return this.vm.checkValidity({
            promoCode: promoCode,
            couponId: couponID,
        });
    }

    // The call for the actions.js method
    async getNewPrice(basePrice, merchantPrice, promoID, couponID, totalPrice) {
        return this.vm.getNewPrice({
            basePrice: basePrice,
            merchantPrice: merchantPrice,
            couponId: couponID,
            promoId: promoID,
            totalPrice: totalPrice,
        });
    }
    // The call for the actions.js method
    async getCouponId(csMatNo, offerType) {
        return this.vm.getCouponId({
            csMatNo: csMatNo,
            offerType: offerType,
        });
    }

    async applyCoupon(couponId, userId) {
        return await this.vm.applyCoupon({
            couponId,
            userId
        });
    }
}

export default CouponManager;
